'use strict';

// stylesheets
require('./../application/stylesheets/core_public_journey');
